import { Component } from 'preact';
import { connect } from 'unistore/preact';
import Help from '../help';
import CONSTANTS, { CACHE, UPI_INTENT_MWEB, RESPONSE_STATUS } from '../../utils/constants';
import { EVENT, log } from '../../common/logger';
import { locale } from '../../utils/i18n';
import { staticPath, getKey, isNullOrUndefined } from '../../utils/common';
import { paymentConfirmation } from '../../utils/formPost';
import { callUpiPollStatus } from '../../controllers/upi';

class UpiIntent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      genericError: '',
      hiddenVisibilityObj: this.props.cache.getData(UPI_INTENT_MWEB.VISIBILITY_HIDDEN_VALUE),
      setIntervalId: '',
      setTimeoutId: '',
      defaultSetTimeoutMS: 480000,
      defaultSetIntervalMS: 5000,
      showSliderSec: false,
      helpText: [
        {
          textSrc: locale('upi_intent.help.step1'),
          imgSrc: `${staticPath()}/assets/images/upi_intent_open_list.png`
        },
        {
          textSrc: locale('upi_intent.help.step2'),
          imgSrc: `${staticPath()}/assets/images/upi_intent_select.png`
        },
        {
          textSrc: locale('upi_intent.help.step3'),
          imgSrc: `${staticPath()}/assets/images/upi_intent_txn_complete.png`
        }
      ],
      paymode: props.paymode,
      isProceedToPayClicked: false,
      isTxtStatusInProgress: false,
      isWindowFocusedInterval: '',
      isWindowFocusedTimeout: ''
    };
    this.focusListener = this.focusListener.bind(this);
    this.pollingTxnStatus = this.pollingTxnStatus.bind(this);
  }

  toggleShowSlider() {
    log({ eventType: EVENT.UPI_INTENT_HELPER, value: !this.state.showSliderSec });
    this.setState(prevState => ({ showSliderSec: !prevState.showSliderSec }));
  }

  transactionStatusCall = () => {
    const setTimeoutId = this.props.cache.getData(CONSTANTS.TIMEOUT_ID);
    const setIntervalId = this.props.cache.getData(CONSTANTS.INTERVAL_ID);
    const config = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
    const retryCounts = this.props.cache.getData(CONSTANTS.ALLOWED_MERCHANT_RETRY_COUNTS);
    clearInterval(setIntervalId);
    clearTimeout(setTimeoutId);
    if (isNullOrUndefined(retryCounts) || retryCounts <= 0) {
      paymentConfirmation(this.props.cache);
    } else {
      this.setState({
        genericError: '',
        isProceedToPayClicked: false,
        isTxtStatusInProgress: false
      });
      this.props.cache
        .getData(CACHE.API)
        .status(
          getKey(config, 'merchant.mid', undefined),
          getKey(config, 'data.orderId', undefined)
        )
        .then(res => {
          if (
            getKey(res, 'body.txnInfo.STATUS') === RESPONSE_STATUS.SUCCESS ||
            getKey(res, 'body.txnInfo.STATUS') === RESPONSE_STATUS.TXN_SUCCESS
          ) {
            paymentConfirmation(this.props.cache);
          } else {
            this.props.cache
              .getData(CACHE.STORE)
              .setState({ overlayValue: null, customOverlayData: null });
          }
        })
        .catch(err => {
          log({ eventType: EVENT.API_FAILED, err });
          paymentConfirmation(this.props.cache);
        });
    }
  };

  onRetryClick() {
    log({
      eventType: EVENT.UPI_INTENT_RETRY,
      RetryCounts: this.props.cache.getData(CONSTANTS.ALLOWED_MERCHANT_RETRY_COUNTS)
    });
    this.transactionStatusCall();
    this.props.cache.getData(CACHE.STORE).setState({
      overlayValue: CONSTANTS.CUSTOM_PROCESSING,
      customOverlayData: {
        heading: locale('upi_intent.loader.retry.validation.heading'),
        desc: locale('upi_intent.loader.retry.validation.desc'),
        handlerText: ''
      }
    });
  }

  pollingTxnStatus() {
    const { defaultSetTimeoutMS, defaultSetIntervalMS } = this.state;

    log({ eventType: EVENT.POLLING_STATUS_CALL });
    this.props.cache.getData(CACHE.STORE).setState({ overlayValue: CONSTANTS.PROCESSING });

    const setIntervalId = setInterval(() => {
      callUpiPollStatus(this.props.cache);
    }, defaultSetIntervalMS);

    const retryCounts = this.props.cache.getData(CONSTANTS.ALLOWED_MERCHANT_RETRY_COUNTS);
    if (!isNullOrUndefined(retryCounts) && retryCounts > 0) {
      setTimeout(() => {
        this.props.cache.getData(CACHE.STORE).setState({
          overlayValue: CONSTANTS.CUSTOM_PROCESSING,
          customOverlayData: {
            heading: locale('upi_intent.loader.retry.heading'),
            desc: locale('upi_intent.loader.retry.desc'),
            handlerText: 'Try Again',
            handler: this.onRetryClick.bind(this)
          }
        });
      }, 5000);
    }

    const setTimeoutId = setTimeout(() => {
      clearInterval(setIntervalId);
      log({ eventType: EVENT.INTENT_SET_TIMEOUT, message: 'submitForm called from setTimeout' });
      this.transactionStatusCall();
    }, defaultSetTimeoutMS);

    this.props.cache.setData(CONSTANTS.TIMEOUT_ID, setTimeoutId);
    this.props.cache.setData(CONSTANTS.INTERVAL_ID, setIntervalId);

    this.setState({ setTimeoutId, setIntervalId, isTxtStatusInProgress: true, genericError: '' });
  }

  focusListener() {
    const {
      hiddenVisibilityObj,
      isProceedToPayClicked,
      isTxtStatusInProgress,
      isWindowFocusedTimeout,
      isWindowFocusedInterval
    } = this.state;
    if (isProceedToPayClicked) {
      if (!document[hiddenVisibilityObj.hidden] && !isTxtStatusInProgress) {
        this.pollingTxnStatus();
      } else if (document[hiddenVisibilityObj.hidden]) {
        clearTimeout(isWindowFocusedTimeout);
        clearInterval(isWindowFocusedInterval);
        this.setState({ genericError: '' });
      }
    }
    log({
      eventType: EVENT.APP_SWITCH,
      value: document[hiddenVisibilityObj.hidden],
      message: `isProceedToPayClicked => ${isProceedToPayClicked}`
    });
  }

  attachListener = () => {
    document.addEventListener(this.state.hiddenVisibilityObj.visibilityChange, this.focusListener);
    log({ eventType: EVENT.UPI_INTENT_ACTIVE, value: true });
  };

  componentDidMount() {
    this.attachListener();
  }

  clearTimer = () => {
    const {
      setIntervalId,
      setTimeoutId,
      hiddenVisibilityObj,
      isWindowFocusedInterval,
      isWindowFocusedTimeout
    } = this.state;
    clearInterval(setIntervalId);
    clearTimeout(setTimeoutId);
    clearInterval(isWindowFocusedInterval);
    clearTimeout(isWindowFocusedTimeout);
    this.props.cache.getData(CACHE.STORE).setState({ overlayValue: null, customOverlayData: null });
    document.removeEventListener(hiddenVisibilityObj.visibilityChange, this.focusListener);
    log({ eventType: EVENT.UPI_INTENT_ACTIVE, value: false });
  };

  componentWillUnmount() {
    this.clearTimer();
  }

  componentWillReceiveProps(props) {
    if (props) {
      if (props.paymode !== UPI_INTENT_MWEB.UPI_INTENT_MWEB) {
        this.clearTimer();
      } else if (
        this.state &&
        this.state.paymode !== props.paymode &&
        props.paymode === UPI_INTENT_MWEB.UPI_INTENT_MWEB
      ) {
        this.setState({ isProceedToPayClicked: false, isTxtStatusInProgress: false });
        this.attachListener();
      }
      this.setState({ paymode: props.paymode, genericError: '' });
    }
  }

  onSubmit = () => {
    log({
      eventType: EVENT.INTENT_PAY_SUBMIT,
      payMode: UPI_INTENT_MWEB.UPI_INTENT,
      message: `onsubmit called`
    });
    this.setState({ genericError: '', isTxtStatusInProgress: false });

    const payload = {
      authMode: CONSTANTS['3D'],
      payerAccount: this.state.upi,
      paymentMode: UPI_INTENT_MWEB.UPI_INTENT,
      selectedPaymentModeId: getKey(this.props, 'option.id')
    };

    this.props.cache.getData(CACHE.STORE).setState({
      overlayValue: CONSTANTS.CUSTOM_PROCESSING,
      customOverlayData: {
        heading: locale('upi_intent.loader.heading'),
        desc: locale('upi_intent.loader.desc')
      }
    });
    this.props.cache.setData(CONSTANTS.IS_BANKPAGE_REQUIRED_BLOCKED, true);

    this.props.cache
      .getData(CACHE.API)
      .pay(payload)
      .then(res => {
        this.props.cache.setData(CONSTANTS.IS_BANKPAGE_REQUIRED_BLOCKED, false);
        log({
          eventType: EVENT.INTENT_PAY_SUBMIT,
          payMode: UPI_INTENT_MWEB.UPI_INTENT,
          message: 'API_SUCCESS',
          response: res
        });

        const deepLink = getKey(res, 'body.deepLinkInfo.deepLink');
        if (deepLink) {
          this.setState({ isProceedToPayClicked: true });
          log({
            eventType: EVENT.INTENT_DEEPLINK_INVOKED,
            value: true,
            message: `Invoked deepLink ${deepLink}`
          });

          let isPSPTrayOpened = false;
          const isWindowFocusedInterval = setInterval(() => {
            if (!document.hasFocus()) {
              clearInterval(isWindowFocusedInterval);
              isPSPTrayOpened = true;
            }
          }, 300);

          const isWindowFocusedTimeout = setTimeout(() => {
            clearInterval(isWindowFocusedInterval);
            this.props.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
            const genericError = isPSPTrayOpened ? '' : locale('upi_intent.psp.not.found');
            this.setState({ genericError });
            log({
              eventType: EVENT.INTENT_DEEPLINK_INVOKED,
              value: false,
              message: `Unable fo open PSP URL ${deepLink}`
            });
          }, 10000);
          this.setState({ isWindowFocusedInterval, isWindowFocusedTimeout });

          document.location.href = deepLink;
          return true;
        }
        throw new Error('Deep Link is not present in PTC response');
      })
      .catch(err => {
        this.props.cache.setData(CONSTANTS.IS_BANKPAGE_REQUIRED_BLOCKED, false);
        this.props.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
        log({
          eventType: EVENT.INTENT_PAY_SUBMIT,
          payMode: UPI_INTENT_MWEB.UPI_INTENT,
          message: `api response error`,
          error: err
        });
        this.setState({ isProceedToPayClicked: false });
        if (
          getKey(err, 'body.resultInfo.resultStatus') === 'F' &&
          getKey(err, 'body.resultInfo.resultMsg')
        ) {
          this.setState({ genericError: getKey(err, 'body.resultInfo.resultMsg') });
        } else {
          this.setState({ genericError: CONSTANTS.GENERIC_ERROR });
        }
      });
  };

  render({ onIntentClick, paymode }, { genericError, showSliderSec, helpText }) {
    return (
      <div>
        <div className={`ptm-upi-main-box ptm-pos-r`} onClick={onIntentClick}>
          <div>
            <div className={`ptm-upi-icon ptm-pos-a`}>
              <img
                className={`ptm-upi-icon-pic ptm-centralized`}
                src={`${staticPath()}/assets/images/bhim-upi-app.png`}
                alt="logos"
              />
              {paymode === UPI_INTENT_MWEB.UPI_INTENT_MWEB && (
                <div className={`ptm-tick ptm-pos-a`}>
                  <span className={`ptm-sign1`} />
                  <span className={`ptm-sign2`} />
                </div>
              )}
            </div>
            <div className={`ptm-upi-heading-txt`}>{locale('upi_intent.label')} </div>
            <div className={`ptm-upi-sbtxt ptm-body-color`}>{locale('upi_intent.desc')}</div>
          </div>
          <a
            class={`ptm-know-more ptm-primary ib fs12 body-bg-global`}
            onClick={e => this.toggleShowSlider(e)}
          >
            {locale('upi_intent.help')}
          </a>
        </div>

        {genericError && <div className={`ptm-msg-red ptm-upierror`}>{genericError}</div>}

        {showSliderSec && (
          <Help
            title={locale('upi_intent.help.title')}
            helpText={helpText}
            closeHelp={e => this.toggleShowSlider(e)}
          />
        )}
      </div>
    );
  }
}

export default connect('cache')(UpiIntent);



// WEBPACK FOOTER //
// ./components/upi-intent/index.js